import {Injectable} from '@angular/core';
import {apiUrl} from '../../config/api.config';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {SendgridApiKey} from '../../config/sendgrid.config';
import {FirebaseAuthenticationService} from '../firebase/authentication.service';
import * as moment from 'moment';
import 'rxjs/add/operator/first';

@Injectable()
export class SendgridApiService {

  constructor(private authService: FirebaseAuthenticationService,
              private http: Http) {
  }


  /**
   *
   * @returns {Observable<any>}
   */
  removeRecipientAfterActiveUser() {
    const email = this.authService.getAuthUser().email;
    return this.deleteRecipientOnContacts(email);
  }


  /**
   * This endpoint allows you to add a Marketing Campaigns recipient.
   * @param {string} email
   * @returns {Observable<any>}
   */
  addRecipientToContacts(email: string): Observable<any> {

    const headers = new Headers({'Content-Type': 'application/json'});
    headers.append('Authorization', 'Bearer ' + SendgridApiKey);

    const options = new RequestOptions({headers: headers});

    const body = JSON.stringify([{
      'email': email
    }]);

    console.log('Body: ', body, options);
    return this.http
      .post('https://api.sendgrid.com/v3/contactdb/recipients', body, options)
      .map(response => response.json());
  }


  /**
   * Find user on Marketing Contactlist and return Sendgrid ID
   * @param {string} email
   * @returns {Observable<any>}
   */
  private searchRecipientOnContactsByEmail(email: string) {
    const headers = new Headers({'Content-Type': 'application/json'});
    headers.append('Authorization', 'Bearer ' + SendgridApiKey);

    const options = new RequestOptions({headers: headers});
    const body = JSON.stringify({
      'email': email
    });

    console.log('Body: ', body, options);
    return this.http.get('https://api.sendgrid.com/v3/contactdb/recipients/search?email=' + email, new RequestOptions(
      {
        headers: headers,
      })
    )
      .map(response => response.json());
  }


  /**
   * Delete contact on Address list by ID
   * @param {string} email
   * @returns {Observable<any>}
   */
  deleteRecipientOnContacts(email: string): Observable<any> {
    return this.searchRecipientOnContactsByEmail(email)
      .switchMap(response => {
        console.log(response);
        if (response) {
          const id = response.recipients[0].id;
          const headers = new Headers({'Content-Type': 'application/json'});
          headers.append('Authorization', 'Bearer ' + SendgridApiKey);

          const options = new RequestOptions({headers: headers});
          const body = JSON.stringify([id]);

          console.log('Body: ', body, options);
          return this.http.delete('https://api.sendgrid.com/v3/contactdb/recipients', new RequestOptions(
            {
              headers: headers,
              body: body
            }))
            .map(res => res.json());
        } else {
          return response;
        }
      });
  }


}








// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/other/sendgrid.service.ts